import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  DigiQuoteThumbnailImageData,
  DigiQuoteThumbnailImageQueryKey,
  UseDigiQuoteThumbnailImageParams,
} from './types';
import { getDigiQuoteThumbnailImageQueryKey } from './util';

export const useDigiQuoteThumbnailImage: QueryFunction<
  DigiQuoteThumbnailImageData,
  [UseDigiQuoteThumbnailImageParams],
  DigiQuoteThumbnailImageQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getDigiQuoteThumbnailImageQueryKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: async ({ signal }) => {
      const response = await request(
        `/quotes/key/${params.digiQuoteToken}/items/${params.quoteItemId}/thumbnail`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      );

      const thumbnailBlob = response instanceof Blob ? response : null;

      return { thumbnailBlob };
    },
  });
};
